import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff, LockKeyhole } from "lucide-react";
import { Reveal } from "../lib/motion";
import { api } from "../lib/api";

export default function StaffLogin() {
  const [passcode, setPasscode] = useState("");
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api("/staff/login", { method: "POST", body: { passcode } });
      nav("/admin/operations");
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="section container" style={{ maxWidth: 460 }}>
      <Reveal>
        <div className="card" style={{ padding: 34 }}>
          <span className="eyebrow red">Staff area</span>
          <h1 style={{ fontSize: 26, margin: "12px 0 8px" }}><LockKeyhole size={20} style={{ verticalAlign: -3, color: "var(--blue-bright)" }} /> Shop tools sign-in</h1>
          <p className="form-note" style={{ marginBottom: 22 }}>
            Shared shop passcode. Sessions last eight hours. Access covers requests, check-in, tickets,
            blog, content and assistant settings.
          </p>
          <form onSubmit={submit} data-testid="staff-login-form">
            <div className="field">
              <label>Shop passcode</label>
              <div style={{ position: "relative" }}>
                <input type={show ? "text" : "password"} value={passcode} onChange={(e) => setPasscode(e.target.value)}
                  required autoFocus style={{ paddingRight: 52 }} data-testid="staff-passcode-input" />
                <button type="button" onClick={() => setShow((s) => !s)} aria-label={show ? "Hide password" : "Show password"}
                  style={{ position: "absolute", right: 14, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", color: "var(--muted)" }}
                  data-testid="staff-passcode-toggle">
                  {show ? <EyeOff size={17} /> : <Eye size={17} />}
                </button>
              </div>
            </div>
            {error && <div className="error-box" role="alert" data-testid="staff-login-error">{error}</div>}
            <button className="btn btn-blue" style={{ width: "100%" }} disabled={busy} data-testid="staff-login-submit">
              {busy ? "Checking…" : "Sign In"}
            </button>
          </form>
        </div>
      </Reveal>
    </main>
  );
}
